/* Set up for axios (chiefly so we can use a global interceptor for spinners) */


import axios from "axios"
export default axios.create({
  //baseURL: "http://localhost/api/v2/", //TODO will need to alter this when we switch over to the server!!!
  baseURL: "https://washoetribe.us/api/v2",
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json",
  }
})
